export default "__VITE_ASSET__DBL32ZC2__"